'use client';

import classNames from 'classnames';
import type { ComponentPropsWithRef, FC } from 'react';

import styles from './checkbox.module.scss';

export interface CheckboxProps extends Omit<ComponentPropsWithRef<'input'>, 'type'> {
  forcedError?: boolean;
}

const defaultInvalidHandler: CheckboxProps['onInvalid'] = (e) => e.preventDefault();

export const Checkbox: FC<CheckboxProps> = ({
  className,
  forcedError,
  onInvalid = defaultInvalidHandler,
  ...props
}) => (
  <span className={classNames(styles.wrapper, className)}>
    <input
      type="checkbox"
      {...props}
      className={classNames(styles.checkbox, forcedError && styles['forced-error'])}
      onInvalid={onInvalid}
    />
    <span className={styles.checkmark}>
      <svg
        className={styles.svg}
        fill="none"
        height="8"
        viewBox="0 0 10 8"
        width="10"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          className={styles.path}
          d="M1.5 5L4 7L8.5 1"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </svg>
    </span>
  </span>
);
